import { Assembler, DeviceClassName } from '@iotv/datamodel';
import { getViewDefinitionForNewObject } from '../../../../v2/components/ExceptionTypesHandling/viewDefinitions';
import { setDefaultValues } from '../../AttributeDefinitions';
const debug = process.env.REACT_APP_DEBUG && false;
export const handleAddNewObject = ({ setNewObject, adjacentFilter, matchedPrimary, viewDefinition: viewDefinitionIn }) => {
    const zombie = { type: adjacentFilter.objectType };
    /** Group predicate - the at smells like someone hasnt bothered catering for where more than one filter is defined */
    if (zombie.type === 'Group') {
        const supportedType = adjacentFilter.filterConfig?.at(0)?.filters.find((config) => config.key === 'supportedType')?.value;
        if (supportedType) {
            zombie.supportedType = supportedType;
        }
        else {
            zombie.supportedType = matchedPrimary?.supportedType;
        }
    }
    if (matchedPrimary?.type === 'Group') {
        if (zombie.type === DeviceClassName) {
            ;
            zombie.deviceType = matchedPrimary.subSupportedType;
        }
    }
    const newObject = Assembler.getInstance(zombie);
    if (!newObject)
        return;
    const viewDefinition = viewDefinitionIn ?? getViewDefinitionForNewObject(newObject);
    if (viewDefinition)
        setDefaultValues(newObject, viewDefinition);
    debug && console.log('Listerlizer handleAddNewObject ', zombie, newObject, viewDefinition);
    setNewObject(newObject);
};
